module.exports = __webpack_public_path__ + "static/img/nav_bg.795f6357.png";